import navigation_unpin from "./unpin";

const debug = "navigation_unpinAndGoTo"

export default async function navigation_unpinAndGoTo(navigationSectionId:string, url:string) {

    navigation_unpin(navigationSectionId)


    gd.navigation.goTo(url)
}
